var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#user';
                    var viewUrl = 'svg/icons.svg#view-user';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };